import React from "react";

// Phase 12.1 — single source of truth for admin page headers
// Pattern:
//   • tracked-uppercase eyebrow ("ADMIN · Taxonomy")
//   • serif page title (Playfair via .font-serif)
//   • muted 1-line description
//   • optional rightSlot for primary action
export default function AdminPageHeader({ eyebrow, title, description, rightSlot }) {
  return (
    <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
      <div className="min-w-0 flex-1">
        {eyebrow && (
          <p
            data-testid="admin-page-eyebrow"
            className="text-[10px] font-semibold uppercase tracking-[0.18em]"
            style={{ color: "var(--page-fg-secondary)" }}
          >
            {eyebrow}
          </p>
        )}
        <h1
          className="font-serif text-3xl font-semibold tracking-tight"
          style={{ letterSpacing: "-0.015em", color: "var(--page-fg)" }}
          data-testid="admin-page-title"
        >
          {title}
        </h1>
        {description && (
          <p
            className="mt-1 max-w-2xl text-sm"
            style={{ color: "var(--page-fg-secondary)" }}
          >
            {description}
          </p>
        )}
      </div>
      {rightSlot && <div className="flex items-center gap-2">{rightSlot}</div>}
    </div>
  );
}
